/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Dashboard
 *| (C) Copyright IBM Corp. 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

define({
	'root': true,
	'cs': true,
	'da': true,
	'de': true,
	'es': true,
	'fi': true,
	'fr': true,
	'he': true,
	'hr': true,
	'hu': true,
	'it': true,
	'ja': true,
	'kk': true,
	'ko': true,
	'no': true,
	'nb': true,
	'nl': true,
	'pl': true,
	'pt': true,
	'pt-br': true,
	'ro': true,
	'ru': true,
	'sl': true,
	'sv': true,
	'th': true,
	'tr': true,
	'zh': true,
	'zh-cn': true,
	'zh-tw': true
});
